import { render, staticRenderFns } from "./AllowanceSubRow.vue?vue&type=template&id=fbbf9014"
import script from "./AllowanceSubRow.vue?vue&type=script&lang=ts"
export * from "./AllowanceSubRow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports